exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\nresolving sonarqube error- Unexpected empty source\r\n*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/dial-beneficiary/dial-beneficiary.component.css
// module id = ../../../../../src/app/dial-beneficiary/dial-beneficiary.component.css
// module chunks = 0